var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.5 70.5V164.5L135.433 141H64.625C63.0669 141 61.5725 140.381 60.4707 139.279C59.369 138.177 58.75 136.683 58.75 135.125V105.75H123.375C124.933 105.75 126.427 105.131 127.529 104.029C128.631 102.927 129.25 101.433 129.25 99.875V64.625H158.625C160.183 64.625 161.677 65.244 162.779 66.3457C163.881 67.4475 164.5 68.9419 164.5 70.5Z",
    fill: "#E1D3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.625 58.75H135.125V35.25C135.125 32.1337 133.887 29.145 131.684 26.9415C129.48 24.7379 126.491 23.5 123.375 23.5H29.375C26.2587 23.5 23.27 24.7379 21.0665 26.9415C18.8629 29.145 17.625 32.1337 17.625 35.25V129.25C17.6284 130.355 17.9436 131.437 18.5343 132.371C19.125 133.306 19.9673 134.054 20.9643 134.531C21.9613 135.008 23.0727 135.194 24.1708 135.068C25.2689 134.942 26.3091 134.509 27.1719 133.818L52.875 113.094V135.125C52.875 138.241 54.1129 141.23 56.3165 143.434C58.5201 145.637 61.5087 146.875 64.625 146.875H133.355L160.828 169.068C161.868 169.909 163.163 170.37 164.5 170.375C166.058 170.375 167.552 169.756 168.654 168.654C169.756 167.552 170.375 166.058 170.375 164.5V70.5C170.375 67.3837 169.137 64.3951 166.934 62.1915C164.73 59.9879 161.741 58.75 158.625 58.75ZM48.8727 101.182L29.375 116.949V35.25H123.375V99.875H52.5666C51.222 99.8752 49.9181 100.337 48.8727 101.182ZM158.625 152.199L139.127 136.432C138.088 135.591 136.793 135.13 135.455 135.125H64.625V111.625H123.375C126.491 111.625 129.48 110.387 131.684 108.184C133.887 105.98 135.125 102.991 135.125 99.875V70.5H158.625V152.199Z",
    fill: "#6921C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 63,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#6921C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 63,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#6921C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 63,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#6921C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/MessagesIcon.bc1b698a.svg";
export { ForwardRef as ReactComponent };